var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.888889 6.66667C0.888889 6.91111 1.08889 7.11111 1.33333 7.11111H6.66667C6.91111 7.11111 7.11111 6.91111 7.11111 6.66667V4.44444C7.11111 4.2 7.31111 4 7.55556 4C7.8 4 8 4.2 8 4.44444V7.11111C8 7.6 7.6 8 7.11111 8H0.888889C0.4 8 0 7.6 0 7.11111V0.888889C0 0.4 0.395556 0 0.888889 0H3.55556C3.8 0 4 0.2 4 0.444444C4 0.688889 3.8 0.888889 3.55556 0.888889H1.33333C1.08889 0.888889 0.888889 1.08889 0.888889 1.33333V6.66667ZM5.33354 0.888889C5.0891 0.888889 4.8891 0.688889 4.8891 0.444444C4.8891 0.2 5.0891 0 5.33354 0H8.00021V2.66667C8.00021 2.91111 7.80021 3.11111 7.55576 3.11111C7.31132 3.11111 7.11132 2.91111 7.11132 2.66667V1.51556L3.05354 5.57333C2.88021 5.74667 2.60021 5.74667 2.42687 5.57333C2.25354 5.4 2.25354 5.12 2.42687 4.94667L6.48465 0.888889H5.33354Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4b76a01f09f1aa4cf8eab2e47545707e.svg";
export { ForwardRef as ReactComponent };